import { Text } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const Container = styled.section<{ $useColumnLayout?: boolean }>`
  ${({ $useColumnLayout }) =>
    $useColumnLayout
      ? `
    position: relative;
    width: 100%;
    max-width: 150px;
    margin: 0 auto;
  `
      : `
    position: absolute;
    bottom: 0;
    left: 0;
  `}
  border: 1px solid #c9c9cb;
  background-color: #fefefe;
  border-radius: 6px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MapContainer = styled.div<{ $color: string }>`
  position: relative;
  display: flex;
  justify-content: center;

  ${({ $color }) => `
    > svg {
      color: ${$color};
    }
  `};
`

export const EventsCountLabel = styled(Text).attrs({
  variant: 'content-03'
})`
  position: absolute;
  top: 50%;
  left: 57%;
  transform: translate(-50%, -57%);
  color: #fff;
`
